import AHRISystemToolCategoryCustomState from "@crescentParts/Store/Data/AHRISystemToolCategory/AHRISystemToolCategoryState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";

import { Draft } from "immer";

const initialState = {
    categoryId:""
};
const reducer = {
    "Custom/AHRISystemToolConfigCategory/Category":(draft:Draft<AHRISystemToolCategoryCustomState>,action:{categoryId:string},)=>{
        draft.categoryId = action.categoryId
    }
}

export default createTypedReducerWithImmer(initialState,reducer);